module.exports = __webpack_public_path__ + "img/balkonverkleidung.6e6b541b.jpg";